import type React from 'react';

import { Chip } from '@mui/material';
import { OrdAvatar } from '@ragu-components/ord-components';

import { useAgentDisplay } from 'src/hooks/useAgentDisplay';

import type { ChipProps } from '@mui/material';
import type { Agent } from '@ragu-components/ord-types';

export interface AgentChipProps extends Omit<ChipProps, 'avatar' | 'label'> {
  record: Agent;
}

/**
 * Renders an Agent as a Chip with the appropriate avatar and label.
 * Automatically handles user vs group agents.
 */
export const AgentChip = ({ record, ...chipProps }: AgentChipProps): React.ReactElement => {
  const { label, avatarId, avatarResource, avatarMeta, avatarIcon } = useAgentDisplay(record);

  const avatar =
    avatarId !== undefined && avatarResource !== undefined ? (
      <OrdAvatar id={avatarId} resource={avatarResource} size='extrasmall' meta={avatarMeta} sx={{ ml: 0.25 }} />
    ) : avatarIcon !== undefined ? (
      <OrdAvatar size='extrasmall' sx={{ ml: 0.25 }}>
        {avatarIcon}
      </OrdAvatar>
    ) : undefined;

  return (
    <Chip
      avatar={avatar as React.ReactElement | undefined}
      label={label}
      variant='outlined'
      size='small'
      {...chipProps}
    />
  );
};

export default AgentChip;
